export const LOTTERY_TICKET_SOURCE = {
  QUEST_COMPLETION: "quest_completion",
  MANUAL_GRANT: "manual_grant",
  VOUCHER_REDEMPTION: "voucher_redemption",
} as const;
export type LOTTERY_TICKET_SOURCE = (typeof LOTTERY_TICKET_SOURCE)[keyof typeof LOTTERY_TICKET_SOURCE];

export const DRAW_PERIOD_STATUS = {
  ACTIVE: "active",
  COMPLETED: "completed",
  CANCELLED: "cancelled",
} as const;
export type DRAW_PERIOD_STATUS = (typeof DRAW_PERIOD_STATUS)[keyof typeof DRAW_PERIOD_STATUS];

export const EXPORT_FORMAT = {
  TXT: "txt",
  CSV: "csv",
  JSON: "json",
} as const;
export type EXPORT_FORMAT = (typeof EXPORT_FORMAT)[keyof typeof EXPORT_FORMAT];

export const ADDRESS_TYPE = {
  EVM: "evm",
  TON: "ton",
} as const;
export type ADDRESS_TYPE = (typeof ADDRESS_TYPE)[keyof typeof ADDRESS_TYPE];
